import React, { useEffect } from 'react';
import {
  MenuOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';
import PageRoutes from "../PageRoutes";
import AppMenu from "../menu/index";

const MobileLayout = ({ viewModel }) => {
  const {
    user,
    accountMenu,
    showMenu,
    openMenu,
    closeMenu,
    colorBgContainer,
  } = viewModel;

  useEffect(() => {
    const handleOpenMenu = () => {
      openMenu();
    };

    window.addEventListener('open-mobile-app-menu', handleOpenMenu);

    return () => {
      window.removeEventListener('open-mobile-app-menu', handleOpenMenu);
    };
  }, [openMenu]);

  return (
    <>
      <AppMenu
        variant="mobile"
        showMenu={showMenu}
        onCloseMenu={closeMenu}
        accountMenu={accountMenu}
        workspaceName={user.work_space.name}
        userFirstName={user.first_name}
      />

      <div
        style={{
          height: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          background: '#f5f5f5',
        }}
      >
        <div
          style={{
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            minHeight: 44,
            padding: 'calc(env(safe-area-inset-top, 0px) + 4px) 8px 4px',
            background: colorBgContainer,
            borderBottom: '1px solid #f0f0f0',
          }}
        >
          <Button type="link" onClick={openMenu} style={{ paddingInline: 8, height: 32 }}>
            <MenuOutlined />
          </Button>
          <b style={{ lineHeight: 1.2 }}>{user.work_space.name}</b>
        </div>

        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            WebkitOverflowScrolling: 'touch',
            padding: 8,
            paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 8px)',
          }}
        >
          <PageRoutes></PageRoutes>
        </div>
      </div>
    </>
  );
};

export default MobileLayout;
